import IForm from '../../../../../../../../types/IForm';
import { LinkchooserLinkType } from '../../../../../../../../types/api/LinkchooserLinkType';
import { InputType } from '../../../../../InputTypes';

export const endpoints = {
  RESOURCE: '/endpoint/resource',
  CONTENT_SUGGEST: '/endpoint/contentSuggest?fq_versionState=publishedOrOnlyDraft&fq_fileLink=false',
  USER_SUGGEST: '/endpoint/userSuggest',
};

/**
 * Returns the Form Data for a given linkType.
 * This is usually done in the backend, but for this tiny plugin was hard coded here.
 */
export const getFormForLinkType = (
  linkType: LinkchooserLinkType,
  text: string,
  link?: string,
  anchor?: string
): IForm => {
  switch (linkType) {
    case 'page':
    case 'attachment':
      return {
        url: endpoints.CONTENT_SUGGEST,
        params: [
          {
            name: 'q',
            value: null,
            type: InputType.COMBOBOX,
            selected: link,
            comboBoxUrl: {
              url: endpoints.CONTENT_SUGGEST,
            },
            constraints: {
              maxLength: 250,
            },
          },
          {
            name: 'anchor',
            value: anchor || '',
            type: InputType.TEXT,
            constraints: {
              maxLength: 250,
              pattern: "^([-?/:@._~!$&'()*+,;=a-zA-Z0-9]|%[0-9a-fA-F]{2})*$",
            },
          },
          {
            required: true,
            name: 'text',
            value: text || '',
            type: InputType.TEXT,
            constraints: {
              maxLength: 250,
            },
          },
          {
            name: 'linkType',
            value: linkType,
            type: InputType.HIDDEN,
          },
        ],
      };
    case 'person':
      return {
        url: endpoints.USER_SUGGEST,
        params: [
          {
            required: true,
            name: 'q',
            value: null,
            type: InputType.COMBOBOX,
            selected: link,
            comboBoxUrl: {
              url: endpoints.USER_SUGGEST,
            },
            constraints: {
              maxLength: 250,
            },
          },
          {
            required: true,
            name: 'text',
            value: text || '',
            type: InputType.TEXT,
            constraints: {
              maxLength: 250,
            },
          },
          {
            name: 'linkType',
            value: 'person',
            type: InputType.HIDDEN,
          },
        ],
      };
    case 'external':
    default:
      return {
        url: endpoints.RESOURCE,
        params: [
          {
            required: true,
            name: 'q',
            value: link && link !== '#' ? link : '',
            type: InputType.TEXT,
            constraints: {
              maxLength: 10000,
            },
          },
          {
            required: true,
            name: 'text',
            value: text || '',
            type: InputType.TEXT,
            constraints: {
              maxLength: 250,
            },
          },
          {
            name: 'linkType',
            value: 'external',
            type: InputType.HIDDEN,
          },
        ],
      };
  }
};
